import {Search} from 'lucide-react';
import {createLucideIcon} from '../create-lucide-icon';

export const SearchIcon = createLucideIcon(Search, 'SearchIcon');
